export default __webpack_public_path__ + "assets/72e962a401438ed1cc3357bfc87dce55.svg";